import { render } from "./expertDetail.vue?vue&type=template&id=33e5a78c&scoped=true"
import script from "./expertDetail.vue?vue&type=script&lang=js"
export * from "./expertDetail.vue?vue&type=script&lang=js"

import "./expertDetail.vue?vue&type=style&index=0&id=33e5a78c&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e5a78c"]])

export default __exports__